export default __webpack_public_path__ + "static/media/arrow-left.eda320d0.svg";